export enum DataTableFormViewMode {
  drawer = 'drawer',
  modalWindow = 'modalWindow',
}
